import React from 'react';
import { SHADCN, R, TYPO, S } from '../theme';

// ── <EmptyState> ─────────────────────────────────────────────────────────────
// État vide générique : icône cerclée + titre + hint optionnel + slot action.
// Centré, padding généreux — destiné aux conteneurs de listes vides.
export default function EmptyState({ icon: Icon, title, hint, action, style }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: `${S[7]}px ${S[5]}px`,
      gap: S[3],
      animation: `sonore-fade-in 320ms cubic-bezier(0.23, 1, 0.32, 1) both`,
      ...style,
    }}>
      {Icon && (
        <div style={{
          width: 48, height: 48,
          borderRadius: R.pill,
          background: SHADCN.sidebarAccent,
          border: `1px solid ${SHADCN.border}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: SHADCN.mutedFg,
          marginBottom: S[2],
        }}>
          <Icon size={20} strokeWidth={1.75} />
        </div>
      )}
      {title && (
        <div style={{ ...TYPO.body, fontWeight: 500, color: SHADCN.fg }}>{title}</div>
      )}
      {hint && (
        <div style={{ ...TYPO.caption, color: SHADCN.mutedFg, maxWidth: 320 }}>{hint}</div>
      )}
      {action && <div style={{ marginTop: S[2] }}>{action}</div>}
    </div>
  );
}
